// app bar, heigth 60px

import React from "react";
import { Link } from "react-router-dom";
import { BellSvg, SpgecSvg } from "../components/Assets";
import { ROUTE_PATHS } from "../constants/Router";
import { useState,useEffect } from "react";
import NotificationApi from "../apis/notification.api";
import '../assets/styles/appbar.css';
const AppBarLeft = () => {
  return (
    <div className="flex" style={{ gap: "5px" }}>
      <img style={{ height: "20px" }} src={SpgecSvg}></img>
      {/* <span style={{
            color: 'white',
            fontWeight: 'bold',
        }}>Union</span>
        <span style={{
            borderRadius: '5px',
            background: 'white',
            color: '#3451D7',
            fontWeight: 'bold',
            padding: '0 2px',
        }}>
            사장님
        </span> */}
    </div>
  );
};
const AppBarRight = () => {
  const [unreadNotiCount,setUnreadNotiCount] = useState(0);
  const getNotificationStatus = async () => {
    const { data } = await NotificationApi.getStatus();
    if (data.data) {
      setUnreadNotiCount(data.data);
    }
  };
  useEffect(()=>{
    getNotificationStatus();
  },[]);
  return (<div>
   {unreadNotiCount>0 &&  <div class="badge"></div>}
    <Link to={ROUTE_PATHS.Notification}>
      <img src={BellSvg}>
      </img>
    </Link>
  </div>
   
  );
};
const AppBar = () => {
  return (
    <div
      className="flex justify-between items-center fixed top-0 left-0 bg-[#3451d7] w-full z-10"
      style={{ height: "60px", padding: "0 20px" }}
    >
      <AppBarLeft />
      <AppBarRight />
    </div>
  );
};
export default AppBar;
